<!-- <app-navbar></app-navbar> -->
<!-- <div id="home"> -->
<app-home></app-home>
<app-services></app-services>
<app-applicant-info></app-applicant-info>
<app-admin-panel></app-admin-panel>
<app-exam-portal></app-exam-portal>
<div id="services">
    <app-features></app-features>
</div>
<div id="form">
    <app-form></app-form>
</div>

<app-footer></app-footer>
